import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="404"
      title={<span className="notfound-title">Página no encontrada</span>}
      subTitle={
        <span className="notfound-subtitle">
          La página que está intentando acceder no está disponible o es incorrecta.
          <br />
          Por favor consulte al administrador
        </span>
      }
      extra={
        <Button
          type="primary"
          size="large"
          onClick={() => navigate("/home")}
          className="notfound-button"
        >
          Ir al inicio
        </Button>
      }
      className="notfound-container"
    />
  );
};

export default NotFound;